// extracted by mini-css-extract-plugin
export default {"heading":"SettingsGeneral_heading__zW3ia","subHeading":"SettingsGeneral_subHeading__5RQgx","headingSm":"SettingsGeneral_headingSm__h1zq7"};